import { useEffect, useState } from "react";
import { Cell, Label, Pie, PieChart, PieLabelRenderProps, ResponsiveContainer, Tooltip } from "recharts"
import { Chart } from "react-google-charts";
import { shelves } from "../../assets/data/constants";
import { useNavigate } from "react-router-dom";

interface ExclusiveShelfPieChartProps {
    library: any[]; 
}

const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7f50', '#00C49F', '#FFBB28', '#FF8042'];

const options = {
    colors: COLORS,
    legend: {
      position: "bottom",
    },
      chartArea: {
        // left: 0,
        top: 20,
        width: '100%', // vergroot dit voor een grotere pie
        height: '80%'
    },
};


const ExlusiveShelfPieChart: React.FC<ExclusiveShelfPieChartProps> = ({library}) => {
    const [formattedData, setFormattedData] = useState<any[]>([]);
    const navigate = useNavigate();

    const formatData = () => {
       const shelfCounts = library.reduce((acc, book) => {
            const shelf = book["Exclusive Shelf"] || "unknown"; // fallback als null
            acc[shelf] = (acc[shelf] || 0) + 1;
            return acc;
        }, {});

        // Omzetten naar de gewenste array structuur
        const result = Object.entries(shelfCounts).map(([name, value]) => ([
            shelves.find((shelf) => shelf.value === name)?.name,
            value
        ]));

        result.unshift(["Shelf", "Count"]);

        setFormattedData(result);
    }
    useEffect(() => {
        formatData();
    }, [library]);

    if (library.length <= 0) {
        // loader
        return (
            <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full mt-[40px] mb-[40px]">
                <div className="loader"></div> 
            </div>
        )
    }
      
    return(
        <div className="bg-white rounded-3xl shadow-lg p-4 min-h-64 h-full">
            <h1 className="text-2xl font-bold  text-[#60637A]">
                    Exclusive Shelfs
            </h1>
            <div  style={{ width: '100%', height: '300px', cursor: 'pointer' }} >
                <Chart
                    chartType="PieChart"
                    data={formattedData}
                    options={options}
                    width={"100%"}
                    height={"100%"}
                    chartEvents={[
                        {
                        eventName: "select",
                        callback: ({ chartWrapper }) => {
                            const chart = chartWrapper?.getChart();
                            const selection = chart?.getSelection();

                            if (selection?.length === 0) return;

                            const selectedItem = selection?.[0];
                            const rowIndex = selectedItem?.row;

                            if (rowIndex !== null) {
                            const label = formattedData[rowIndex + 1][0]; // +1 vanwege headers
                            const value = shelves.find((shelf) => shelf.name === label)?.value

                            navigate('/stats/details?value=' + value + '&type=exclusive-shelf');
                            }
                        },
                        },
                    ]}
                />
            </div>
        </div>
    )
    
}

export default ExlusiveShelfPieChart